import { useState, useEffect } from 'react';
import { useApi } from './useApi.js';

export function useRoles() {
  const api = useApi();
  const [roles, setRoles] = useState([]);
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/rules/roles')
      .then(data => {
        setRoles(data.roles || []);
        setSkills(data.skills || []);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const roleNames = roles.map(r => r.name);
  const skillNames = skills.map(s => s.name);

  return { roles, skills, roleNames, skillNames, loading, setRoles, setSkills };
}
